export const translation = {
  "connecting": "连接中...",
  "offline": {
    "title": "抱歉！",
    "message": "当前暂无答题活动进行"
  },
  "video": {
    "tapToUnmute": "点击取消静音",
    "tryVideoAgain": "重试播放视频"
  },
  "countdown": {
    "soon": "即将开始...",
    "aboutToStart": "马上开始...",
    "kickOff": "开始"
  },
  "join": {
    "instruction": "参与答题！",
    "joinInNow": "立即参与！",
    "screenName": "昵称",
    "enterScreenName": "输入昵称",
    "button": {
      "join": "加入",
      "next": "下一步"
    },
    "chooseTeam": "选择你要加入的队伍",
    "hello": "你好",
    "vs": "– vs –",
    "player": "玩家",
    "players": "玩家列表"
  },
  "form": {
    "name": "姓名",
    "email": "电子邮箱",
    "mobile": "手机号码",
    "iAgreeToThe": "我同意 <0>{{terms}}</0>",
    "terms": "服务条款",
    "termsLink": "https://piing.events/terms-quiiz",
    "privacyPolicy": "隐私政策",
    "privacyPolicies": "隐私政策",
    "privacyLink": "https://piing.events/privacy",
    "ok": "确定"
  },
  "errorBoundary": {
    "connectionErrorTitle": "抱歉，连接失败",
    "connectionError": "请 <0>{{tryAgain1}}</0>",
    "notConnectionErrorTitle": "抱歉，出现错误",
    "notConnectionError": "请 <0>{{tryAgain2}}</0> 或 <1>{{contactUs}}</1> 反馈问题",
    "tryAgain1": "重试",
    "tryAgain2": "重试",
    "contactUs": "联系我们",
    "emailSubject": "答题活动问题反馈",
    "emailBody": "请在下方描述具体问题"
  },
  "validation": {
    "nameTaken": "该昵称已被使用！",
    "problemJoining": "加入游戏失败",
    "notReadyForPlayers": "游戏尚未开放入场",
    "checkName": "请核对你的昵称",
    "checkEmail": "请核对你的电子邮箱",
    "checkMobile": "请核对你的手机号码",
  },
  "leaderboard": {
    "teamsLeaderboard": "队伍排行榜",
    "playersLeaderboard": "个人排行榜",
    "team": "队伍",
    "name": "名称",
    "score": "分数",
    "bonus": "奖励分数",
    "wins": "获胜！",
    "tab": {
      "topPlayers": "顶尖玩家",
      "topTeams": "顶尖队伍",
      "yourTeam": "你的队伍",
    }
  },
  "score": {
    "q": "题目",
    "correct": "正确",
    "incorrect": "错误",
    "speedBonus": "速度奖励",
    "team": "队伍",
    "overall": "总榜",
    "score": "分数",
    "rank": "排名",
  },
  "question": {
    "question": "题目",
    "milliseconds": "毫秒",
  }
};
